<template>
  <div
    :class="{ 'pb-divider': true, ...className }"
    :style="`--divider-distance: ${distance}rem`"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "PbDivider",
  props: {
    distance: {
      type: Number,
      default: () => 1
    },

    className: {
      type: Object,
      default: () => {}
    }
  },
  methods: {}
};
</script>
<style lang="scss">
.pb-divider {
  margin-bottom: var(--divider-distance);
}
</style>
